<div class="mb-3 message-card">
  <div>
    <mwp-text-translate text="One or more of your selected benefits allows for you to enter your Primary Care Physician (PCP) information, if you have it available." jsonKey="pcp1" />
  </div>
  <div>
    <mwp-text-translate text="If you do not enter your PCP information below you will be assigned a random PCP by the carrier." jsonKey="pcp2" />
  </div>
</div>
<div class="mb-3">
  <form [formGroup]="pcpFormGroup">
    <div formArrayName="grids" class="content-container">
      @for (grid of gridArray; track grid; let i = $index) {
        <div [formGroupName]="i">
          <div class="mt-2 mb-1 title">
            {{grid.value.panelHeaderLabelForDisplay}}
          </div>
          @if (grid.value.pcpLinkURL) {
            <div class="my-2">
              <button class="mwp-button" (click)="openTab(grid.value.pcpLinkURL)">
                {{ grid.value.pcpLinkText}}
              </button>
            </div>
          }
          <div formArrayName="details" class="content">
            <table>
              <thead>
                <tr>
                  <th>
                    <mwp-text-translate text="Member" jsonKey="member" />
                  </th>
                  <th>
                    <mwp-text-translate text="PCP First Name" jsonKey="pcpFirstName" />
                  </th>
                  <th>
                    <mwp-text-translate text="PCP Last Name" jsonKey="pcpLastName" />
                  </th>
                  <th>
                    <mwp-text-translate text="PCP ID" jsonKey="pcpID" />
                  </th>
                  <th>
                    <mwp-text-translate text="Existing Patient" jsonKey="pcpExistingPatient" />
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (item of gridDetailArray(i); track item; let j = $index) {
                  <tr [formGroupName]="j">
                    <td>
                      {{item.value.coveredMemberName}}
                    </td>
                    <td>
                      <input formControlName="pcpFirstName">
                    </td>
                    <td>
                      <input formControlName="pcpLastName">
                    </td>
                    <td>
                      <input formControlName="pcpId">
                    </td>
                    <td>
                      <mat-checkbox formControlName="isPreExisting"></mat-checkbox>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <div class="footer">
        <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="pcpFormGroup.invalid" (emitComplete)="completeForm()"></mwp-benefit-enrollment-wizard-control>
      </div>
    </div>
  </form>
</div>
